// eslint-disable-next-line no-restricted-imports
import './App.css';
import { ET_TIMEZONE } from '@library/utils/dateTime';
import { RouterProvider } from 'react-router-dom';
import { Settings } from 'luxon';
import { router } from '@bo-components/navigation/Router';
import { useEffect } from 'react';
import { useSplitFlag } from '@bo-hooks/useSplitFlag';

export function App() {
  const { treatment: availableRoutes, isReady } = useSplitFlag({
    flagName: 'BACKOFFICE-active-modules'
  });

  useEffect(() => {
    Settings.defaultZone = ET_TIMEZONE;
  }, []);

  return (
    <div className="bg-soFresh-100 h-screen w-screen text-base">
      {isReady && <RouterProvider router={router({ availableRoutes })} />}
    </div>
  );
}
